<template>
    <!-- 奖牌榜 -->
  <div class="sub-page">
    <div class="main">
      <div class="row title">
        <div class="col-1">排名</div>
        <div class="col-2">代表队</div>
        <div class="col-3">
          <img src="../../../../../district/assets/image/1.png" alt="">
        </div>
        <div class="col-4">
          <img src="../../../../../district/assets/image/2.png" alt="">
        </div>
        <div class="col-5">
          <img src="../../../../../district/assets/image/3.png" alt="">
        </div>
        <div class="col-6">
          <img src="../../../../../district/assets/image/4.png" alt="">
        </div>
      </div>
      <div class="row">
        <a-collapse v-model="activeKey" expandIconPosition="right" class="coll" :bordered="false">
            <a-collapse-panel key="1">
              <div slot="header">
                <div class="row-list">
                  <div class="col-1">1</div>
                  <div class="col-2">参赛代表队参赛代表队参赛代表队参赛代表队</div>
                  <div class="col-3">23</div>
                  <div class="col-4">43</div>
                  <div class="col-5">12</div>
                  <div class="col-6">52</div>
                </div>
             </div>
             <div class="medal">
              <div class="tab-medal">
                <div class="tab-item" v-for="(item,index) in medalList" :key="index" @click="medalNum(index)">
                  <div>{{item.name}}</div>
                  <div v-show="medalIndex==index"></div>
                </div>
              </div>
              <div class="player-list">
                <div class="player-item title">
                  <div class="left">运动员/运动队</div>
                  <div class="center">获奖项目</div>
                  <div class="right"></div>
                </div>
                <div class="player-item" v-for="(item,index) in playerList" :key="index">
                  <div class="left">
                    <img :src="item.image" alt="">
                    <span>{{item.name}}</span>
                  </div>
                  <div class="center">{{item.proname}}</div>
                  <div class="right" @click="scheduleDetail(item)">查看详情<a-icon type="arrow-right" /></div>
                </div>
              </div>
             </div>
            </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
          activeKey:1,
          medalList:[
            {name:"金牌"},
            {name:"银牌"},
            {name:"铜牌"},
          ],
          medalIndex:0,
          playerList:[
            {
              id:1,name:"运动员",proname:"女子3000米障碍1",prlayerId:3,image:require('../../../../assets/avatar.jpg')
            },
            {
              id:2,name:"运动员",proname:"女子3000米障碍2",prlayerId:3,image:require('../../../../assets/avatar.jpg')
            },
            {
              id:3,name:"运动员",proname:"女子3000米障碍3",prlayerId:3,image:require('../../../../assets/avatar.jpg')
            },
          ]
        }
    },
    mounted () {
    },
    methods: {
        medalNum(index) {
            this.medalIndex = index
        },
        scheduleDetail(item){
         this.$emit('scoreDetail',item)
        }
    },
}
</script>

<style lang="scss" scoped>
.sub-page{
  width: 100%;
  .main{
    width: 1200px;
    margin: 0 auto;
    .row{
      line-height: 70px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
      img{
        width: 60px;
        height: 60px;
      }
      .col-1{
         width: 116px;
          text-align: left;
      }
      .col-2{
        width:320px;
         text-align: left;
         overflow: hidden;
      }
      .col-3{
        width: 240px;
      }
      .col-4{
        width: 220px;
      }
      .col-5{
        width: 228px;
      }
      .col-6{
        width: 240px;
      }
    }
    .title{
      height: 70px;
      border-bottom: 4px solid #ACD0FD;
      padding-left: 30px;
      padding-right: 30px;
      text-align: center;
    }
    .coll{
      width: 100%;
      background-color: #ffffff;
      .row-list{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 18px;
        line-height: 40px;
        font-weight: 600;
        // text-align: center;
        .col-1{
          width: 116px;
          text-align: left;
          padding-left: 20px;

        }
        .col-2{
          width:342px;
          text-align: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .col-3{
          width:228px;
        }
        .col-4{
          width: 228px;
        }
        .col-5{
          width: 228px;
        }
        .col-6{
          width: 228px;
        }
      }
      .medal{
          width: 100%;
          .tab-medal{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .tab-item{
              height: 70px;
              line-height: 70px;
              cursor: pointer;
              margin-right: 20px;
              div:first-child{
                width: 100%;
                height: 50px;
                padding: 0 5px;
                color: #000000;
                font-size: 18px;
              }
              div:last-child{
                width: 100%;
                height: 3px;
                background-color: #AA1F23;
              }
            }
          }
        }
      /deep/ .ant-collapse-header{
        height: 70px;
        text-align: center;
        border-bottom: 1px solid #E1E1E1;
      }
      .player-list{
        width: 100%;
        .player-item{
          height: 60px;
          line-height: 60px;
          display: flex;
          font-size: 14px;
          color: #000000;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px solid #E1E1E1;
          padding-left: 30px;
        }
        .left{
          width: 200px;
          display: flex;
          line-height: 60px;
          img{
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin-top: 10px;
            margin-right: 10px;
          }
        }
        .center{
          width: 800px;
        }
        .right{
          // width: 200px;
          cursor: pointer;
          margin-right: auto;
          text-align: right;
          color: #999999;
          font-size: 14px;
          width: 80px;
        }
        .title{
          font-size: 16px;
          text-align: left;
        }
      }
    }
   
  }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/match/trackfield/components/TrackfieldMedalTable.vue